<app-template-signature [value]="value" [control]="control" [label]="label" />
